"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { rotateVideoOperation } from "../_operations/rotateVideo";

export function RotateVideoContent() {
  return <MediaWorkspace operation={rotateVideoOperation} />;
}
